/* istanbul ignore file */

import React from 'react';
import styled from 'styled-components';
import { Nav } from '@catalogo/core-nav';

const errorsFeedback = {
  wordCountReached: 'sua pergunta deve ter pelo menos duas palavras ;)',
  timeoutFinish: 'Oba! Você já pode enviar sua pergunta :)',
  timeoutRuning: 'é possível enviar apenas uma pergunta por minuto, tá?',
  default: () => ({
    title: 'a gente teve um problema :(',
    message: 'Mas você pode tentar enviar sua pergunta de novo, tá?',
  }),
  pejorativo: () => ({
    title: 'essa pergunta parece ter conteúdo inadequado',
    message: 'Revise sua pergunta e tente de novo :)',
  }),
  competidor: () => ({
    title: 'essa pergunta parece ter conteúdo inadequado',
    message: 'Revise sua pergunta e tente de novo :)',
  }),
  pagamento: qnaFaqUrl => ({
    title: 'esse espaço é para fazer perguntas sobre as características do produto, tá?',
    message: (
      <span>
        Sua dúvida não é sobre o produto? <Link to={qnaFaqUrl}>Nossa FAQ</Link> pode te ajudar :)
      </span>
    ),
  }),
  entrega: qnaFaqUrl => ({
    title: 'esse espaço é para fazer perguntas sobre as características do produto, tá?',
    message: (
      <span>
        Sua dúvida não é sobre o produto? <Link to={qnaFaqUrl}>Nossa FAQ</Link> pode te ajudar :)
      </span>
    ),
  }),
  precoFrete: qnaFaqUrl => ({
    title: 'esse espaço é para fazer perguntas sobre as características do produto, tá?',
    message: (
      <span>
        Sua dúvida não é sobre o produto? <Link to={qnaFaqUrl}>Nossa FAQ</Link> pode te ajudar :)
      </span>
    ),
  }),
  prazoFrete: qnaFaqUrl => ({
    title: 'esse espaço é para fazer perguntas sobre as características do produto, tá?',
    message: (
      <span>
        Sua dúvida não é sobre o produto? <Link to={qnaFaqUrl}>Nossa FAQ</Link> pode te ajudar :)
      </span>
    ),
  }),
  precoItem: qnaFaqUrl => ({
    title: 'esse espaço é para fazer perguntas sobre as características do produto, tá?',
    message: (
      <span>
        Sua dúvida não é sobre o produto? <Link to={qnaFaqUrl}>Nossa FAQ</Link> pode te ajudar :)
      </span>
    ),
  }),
  modeloItem: qnaFaqUrl => ({
    title: 'esse espaço é para fazer perguntas sobre as características do produto, tá?',
    message: (
      <span>
        Sua dúvida não é sobre o produto? <Link to={qnaFaqUrl}>Nossa FAQ</Link> pode te ajudar :)
      </span>
    ),
  }),
  estoque: qnaFaqUrl => ({
    title: 'esse espaço é para fazer perguntas sobre as características do produto, tá?',
    message: (
      <span>
        Sua dúvida não é sobre o produto? <Link to={qnaFaqUrl}>Nossa FAQ</Link> pode te ajudar :)
      </span>
    ),
  }),
  trocarPedido: qnaFaqUrl => ({
    title: 'esse espaço é para fazer perguntas sobre as características do produto, tá?',
    message: (
      <span>
        Sua dúvida não é sobre o produto? <Link to={qnaFaqUrl}>Nossa FAQ</Link> pode te ajudar :)
      </span>
    ),
  }),
};

/* istanbul ignore next */
const Link = styled(Nav)`
  text-decoration: underline;
  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export default errorsFeedback;
export { errorsFeedback };
